import styles from "../web.css";
import Head from "next/head";

export default () => {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="" />
        <meta name="keywords" content="" />
        <meta name="robots" content="noindex" />
        <meta name="description" content="Terms of Service" />
        <link rel="canonical" href="#/terms-of-service" />
        <meta property="og:title" content="Terms of Service" />
        <meta property="og:description" content="Terms of Service" />
        <meta property="og:image:width" content="" />
        <meta property="og:image:height" content="" />
        <meta
          property="og:url"
          content="#/terms-of-service"
        />
        <meta name="twitter:title" content="Terms of Service" />
        <meta name="twitter:description" content="Terms of Service" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="" />
        <title>Terms of Service</title>
      </Head>
      <div className="jumbotron hero industry-jumbotron">
        <div className="container">
          <div className="row flex-center">
            <div className="col-md-12">
              <div className="industry-header">
                <h1>
                  <strong>Terms Of Services</strong>
                </h1>
                <h2>
                  {/*Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Minus, alias? */}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="terms-service">
        <div className="container">
          <ul className="nav nav-tabs">
            <li role="presentation" className="active">
              <a className="nav-link" data-toggle="tab" href="#terms">
                General Terms of use
              </a>
            </li>
            <li role="presentation">
              <a className="nav-link" data-toggle="tab" href="#privacy">
                Privacy Policy
              </a>
            </li>
          </ul>
          <div className="tab-content">
            <div
              className="tab-pane fade in active"
              id="terms"
              role="tabpanel"
              aria-labelledby="terms-tab">
              <div className="terms-cont general">
                <div className="_intro-title">
                  <p>
                    These Terms of Use govern your use of the 1Gov website
                    (“Site”) which is provided by Crown Interactive (“the
                    Company”). Please read them carefully as they affect your
                    rights and liabilities under the law. By accessing this
                    website, you are indicating your acceptance of these Terms
                    of Use, the privacy policy and any other applicable
                    document. If you do not agree to these Terms of Use, please
                    do not access and or use the Site.
                  </p>
                </div>
                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">1.</span>
                    <span className="__bullet-title">AMENDMENTS</span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet "></span>
                    <span className="__list-single">
                      We may update these Terms of Use from time to time for
                      legal or regulatory reasons or for the proper operation of
                      the Site. Any changes will be notified to you via the
                      e-mail address provided by you on registration or via a
                      suitable announcement on the Site. The changes will apply
                      to the use of the Site after we have given notice. If you
                      do not wish to accept the changes to our Terms of Use, you
                      should not continue to use the Site. If you continue to
                      use the Site after the date on which the change comes into
                      effect, your use of the Site indicates your agreement to
                      be bound by the new Terms of Use.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">2.</span>
                    <span className="__bullet-title">REGISTRATION</span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">2.1</span>
                    <span className="__list-single">
                      To access this Site or some of the resources it has to
                      offer, you may be asked to provide certain registration
                      details such as an email address, credit card information,
                      username and password or other information.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">2.2</span>
                    <span className="__list-single">
                      It is a condition of your use that all the information you
                      provide on this Site is correct, current and complete. If
                      the Company believes that the information you provide is
                      not correct, or complete, the Company has the right to
                      refuse you access to this Site or any of its resources,
                      and to terminate or suspend your access at any time
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">2.3</span>
                    <span className="__list-single">
                      When you register to use the Site you will be asked to
                      create a password. In order to prevent fraud, you must
                      keep this password confidential and must not disclose it
                      or share it with anyone. If you know or suspect that
                      someone else knows your password, you should immediately
                      change the password and or notify us by contacting
                      {/*............. */}
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">2.4</span>
                    <span className="__list-single">
                      If the Company has a reason to believe that there is
                      likely to be a breach of security or misuse of the Site,
                      we may require you to change your password or we may
                      suspend your account.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">3.</span>
                    <span className="__bullet-title">AGE OF USERS</span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet "></span>
                    <span className="__list-single">
                      Children under the age of 18 should not use this service
                      and parents or legal guardians should not agree to these
                      Terms of Use on their behalf. If we become aware that a
                      child under 18 has provided or attempted to provide us
                      with personal information, we will use our best effort to
                      remove the information permanently from our files.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">4.</span>
                    <span className="__bullet-title">
                      INFORMATION YOU PROVIDE
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1</span>
                    <span className="__list-single">
                      You may not post, send, submit, publish, or transmit in
                      connection with this Site any material that:
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.1</span>
                    <span className="__list-single">
                      You do not have the right to post, including proprietary
                      material of any third party;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.2</span>
                    <span className="__list-single">
                      Advocates illegal activity or discusses an intent to
                      commit an illegal act;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.3</span>
                    <span className="__list-single">
                      Is vulgar, obscene, pornographic, or indecent;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.4</span>
                    <span className="__list-single">
                      Does not pertain directly to this Site;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.5</span>
                    <span className="__list-single">
                      Threatens or abuses others, libels, defames, invades
                      privacy, stalks, is obscene, pornographic, racist,
                      abusive, harassing, threatening or offensive;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.6</span>
                    <span className="__list-single">
                      Seeks to exploit or harm children by exposing them to
                      inappropriate content, asking for personally identifiable
                      details, or otherwise;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.7</span>
                    <span className="__list-single">
                      Infringes any intellectual property or other right of any
                      entity or person, including violating anyone’s copyright
                      or trademarks or their rights of publicity;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.8</span>
                    <span className="__list-single">
                      Violates any law or may be considered to violate any law
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.9</span>
                    <span className="__list-single">
                      Impersonates or misrepresents your connection to any other
                      entity or person or otherwise manipulates headers or
                      identifies to disguise the origin of the content;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.10</span>
                    <span className="__list-single">
                      Advertises any commercial endeavor (e.g, offering for sale
                      products or services) or otherwise manipulates headers or
                      identifiers to disguise the origin of the content;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.11</span>
                    <span className="__list-single">
                      Solicits funds, advertisers or sponsors;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1.12</span>
                    <span className="__list-single">
                      Contains hyper-links to other sites that contain content
                      that falls within the descriptions set forth above.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list_text-cont">
                    <span className="bullet">5.</span>
                    <span className="__list-single">
                      Children under the age of 18 should not use this service
                      and parents or legal guardians should not agree to these
                      Terms of Use on their behalf. If we become aware that a
                      child under 18 has provided or attempted to provide us
                      with personal information, we will use our best effort to
                      remove the information permanently from our files.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">6.</span>
                    <span className="__bullet-title">PRIVACY STATEMENT</span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet "></span>
                    <span className="__list-single">
                      Your use of this Site signifies your continuing consent to
                      the Company’s Privacy Policy which you can examine any
                      time by clicking of the “privacy” link on the Site.
                      Personal information that you supply to the Company and
                      any information about your use of 1Gov that we obtain
                      will be subject to the Company’s Privacy Policy on this
                      Site.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">7.</span>
                    <span className="__bullet-title">
                      AVAILABILITY OF THE SITE
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet">7.1</span>
                    <span className="__list-single">
                      Although we aim to offer you the best service possible, we
                      make no promise that the Site will meet your requirements.
                      We cannot guarantee that the services will be fault-free.
                      If a fault occurs with the Site you should report it to
                      {/*…………………..*/} and we will attempt to correct the fault
                      as soon as we reasonably can.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet">7.2</span>
                    <span className="__list-single">
                      Your access to the Site may be occasionally restricted to
                      allow for repairs, maintenance or the introduction of new
                      facilities or services. We will attempt to restore the
                      service as soon as we reasonably can.
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="privacy"
              role="tabpanel"
              aria-labelledby="privacy-tab">
              <div className="terms-cont general">
                <div className="_intro-title">
                  <p>
                    The Privacy Policy covers your use of the 1Gov website
                    (“Site”) which is provided by Crown Interactive. Please read
                    them carefully as they affect your rights and liabilities
                    under the law. By accessing this website, you are indicating
                    your acceptance of the Privacy Policy, our terms of use and
                    any other applicable document. If you do not agree to terms
                    of the Privacy Policy, please do not access and or use the
                    Site
                  </p>
                </div>
                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">1.</span>
                    <span className="__bullet-title">general</span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet">1.1</span>
                    <span className="__list-single">
                      The information we gather from you allows us to
                      personalize and continually improve your experience on the
                      Site. We collect personal information when you register
                      with us, when you access the Site or our products or
                      services on the Site.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet">1.2</span>
                    <span className="__list-single">
                      When you register we may ask for information such as your
                      name, e-mail address, birth date, gender, occupation,
                      credit card information, and information about your
                      assets. Once you register with us, you are not anonymous
                      to us.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet">1.3</span>
                    <span className="__list-single">
                      We collect information about your transactions with us,
                      including information about your use of financial products
                      and services that we offer.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet">1.4</span>
                    <span className="__list-single">
                      We automatically receive and record information on our
                      server logs from your browser, including your IP address,
                      cookie information, and the page you request.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet">1.5</span>
                    <span className="__list-single">
                      We do not sell products and services for purchase by
                      minors. We do not knowingly transact or provide any
                      services to persons under the age of 18. Minors under the
                      age of 18 are not permitted to register on this Site or
                      use any functionality for which registration is required.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">2.</span>
                    <span className="__bullet-title">
                      information and sharing disclosure
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">2.1</span>
                    <span className="__list-single">
                      The information that we collect about you is critical to
                      our business. We respect and value this information and do
                      not want to jeopardize the flow of information on the
                      Site. Therefore we are not in the business of selling this
                      information to other Web sites or businesses. There are
                      very limited circumstances where we do share some of your
                      information and this is outlined immediately below.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">2.2</span>
                    <span className="__list-single">
                      We provide the information to trusted partners who work on
                      behalf of or with us under confidentiality agreements.
                      These companies may use your personal information to help
                      us communicate with you about our offers and our marketing
                      partners. However, these companies do not have any
                      independent right to share this information.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">2.3</span>
                    <span className="__list-single">
                      We respond to subpoenas, court orders, or legal process,
                      or to establish or exercise our legal rights or defend
                      against legal claims;
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">2.4</span>
                    <span className="__list-single">
                      We believe it is necessary to share information in order
                      to investigate, prevent, or take action regarding illegal
                      activities, suspected fraud, situations involving
                      potential threats to the physical safety of any person,
                      violations of our terms of use, or as otherwise required
                      by law; and
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">2.5</span>
                    <span className="__list-single">
                      We transfer information about you if we are acquired by or
                      merged with another company. In this event, we will notify
                      you before information about you is transferred and
                      becomes subject to a different privacy policy.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">2.6</span>
                    <span className="__list-single">
                      We do not intend to sell, share, or rent information
                      obtained on this Site other than as discussed in this
                      privacy policy
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">3.</span>
                    <span className="__bullet-title">
                      product information and offers
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet">3.1</span>
                    <span className="__list-single">
                      The email address information that you provide us with may
                      be used to contact you about other product and service
                      offers from Crown Interactive We may also use that
                      information to let you know of additional products and
                      services from other companies that you might be interested
                      in.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet">3.2</span>
                    <span className="__list-single">
                      If you do not wish to receive these kinds of
                      communications, you can opt out by unchecking the
                      appropriate email offer announcements boxes during
                      registration. In addition, you can choose not to receive
                      such information by opting-out on the Customer Profile
                      page on the Site.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">4.</span>
                    <span className="__bullet-title">cookies</span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.1</span>
                    <span className="__list-single">
                      Like many other websites, we use cookies to identify you
                      as a user and to customize and improve our services. We
                      may set and access our cookies on your computer. A cookie
                      is a small text file that is stored on a user’s computer
                      for record-keeping purposes.
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet sub-bullet">4.2</span>
                    <span className="__list-single">
                      Your web browser allows you to control and limit cookies
                      on your computer. If you reject cookies, you may still use
                      the Site, but your ability to use some areas or functions
                      of the Site may be limited.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">5.</span>
                    <span className="__bullet-title">
                      confidentiality and security
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet "></span>
                    <span className="__list-single">
                      Your Account Information with us is password-protected. In
                      certain areas we use industry-standard SSL-encryption to
                      protect data transmissions.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">6.</span>
                    <span className="__bullet-title">
                      CORRECTION/UPDATING OF PERSONAL INFORMATION
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet "></span>
                    <span className="__list-single">
                      If you provide personally identifiable information changes
                      (such as an email address or zip code), Crown Interactive
                      will endeavor to provide a way to correct, update or
                      remove your personal date. This can usually be done at the
                      Customer Profile Page
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">7.</span>
                    <span className="__bullet-title">DATA STORAGE</span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet "></span>
                    <span className="__list-single">
                      We will only retain personal information on our servers
                      for as long as an account is active. Once an account has
                      been deactivated, your information is stored on our
                      servers for as long as necessarily obligated by law.
                    </span>
                  </div>
                </div>

                <div className="_list-cont">
                  <div className="__list-title">
                    <span className="main-bullet">8.</span>
                    <span className="__bullet-title">
                      CHANGES TO THIS PRIVACY POLICY
                    </span>
                  </div>
                  <div className="__list_text-cont">
                    <span className="bullet "></span>
                    <span className="__list-single">
                      We may update this policy. We will notify you about
                      significant changes in the way we treat personal
                      information by sending a notice to the primary e-mail
                      address specified in your account with us or by placing a
                      prominent notice on our Site.
                    </span>
                  </div>
                </div>

                <p className="end-of-terms">end of terms of service</p>
                {/* <p className="questions">
                  If you have any questions or concerns regarding this
                  Agreement, please contact us at <a href="#">info@cicod.com</a>
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};
